import React from "react";
import AllTypesCampaigns from "../component/sections/campaigns/AllTypesCampaigns";
import AllCampaigns from "../component/sections/campaigns/AllCampaigns";
import AllTypesBannerCampaigns from "../component/sections/campaigns/banner/AllTypesBannerCampaigns";
import AllTypesNativeCampaigns from "../component/sections/campaigns/native/AllTypesNativeCampaigns";
import middleware from "./middlewares/middleware";
import AddBannerSimpleCampaign from "../component/sections/campaigns/banner/simple/AddCampaign";
import EditBannerSimpleCampaign from "../component/sections/campaigns/banner/simple/EditCampaign";
import ViewBannerSimpleCampaign from "../component/sections/campaigns/banner/simple/ViewCampaign";
import AddNativeSimpleCampaign from "../component/sections/campaigns/native/simple/AddCampaign";
import EditNativeSimpleCampaign from "../component/sections/campaigns/native/simple/EditCampaign";
import routesManageCampaigns from "./manage-campaigns";
import AddGroupSitePublisherContainerCampaignBanner from "../component/sections/campaigns/banner/simple/AddGroupSitePublisherContainerCampaignBanner";
import AllCampaignCustomer from "../component/sections/campaigns/customer/AllCampaign";
import ViewCampaignsCustomerBanner from "../component/sections/campaigns/customer/banner/ViewCampaing";

const campaignsRoutes = [
  {
    path: "/campaigns/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCampaigns />,
        "AllCampaigns"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/all-type",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTypesCampaigns />,
        "AllTypesCampaigns"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/all-type-banner",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTypesBannerCampaigns />,
        "AllTypesBannerCampaigns"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/all-type-native",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTypesNativeCampaigns />,
        "AllTypesNativeCampaigns"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/banner/simple/add-group-site-publisher",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddGroupSitePublisherContainerCampaignBanner />,
        "AddGroupSitePublisherContainerCampaignBanner"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/banner/simple/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddBannerSimpleCampaign />,
        "AddBannerSimpleCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/banner/simple/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditBannerSimpleCampaign />,
        "EditBannerSimpleCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/banner/simple/view/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewBannerSimpleCampaign />,
        "ViewBannerSimpleCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/native/simple/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddNativeSimpleCampaign />,
        "AddNativeSimpleCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/native/simple/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditNativeSimpleCampaign />,
        "EditNativeSimpleCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/customer/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCampaignCustomer />,
        "AllCampaignCustomer"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/customer/banner/simple/view/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewCampaignsCustomerBanner />,
        "ViewCampaignsCustomerBanner"
      );
    },
    exact: true,
  },
  ...routesManageCampaigns,
];

export default campaignsRoutes;
